// extracted by css-extract-rspack-plugin
export default {"indicator":"indicator-aPnhf_","dot":"dot-HFZ7Qn","count":"count-CVxZdp"};